import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import '../styles/mobile-phone-fab.css';

const MobilePhoneFAB = ({ phoneNumber = '8885319005' }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // Only show on mobile devices
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  if (!isMobile || !isVisible) return null;

  return (
    <a href={`tel:+1${phoneNumber}`} className="mobile-phone-fab">
      <Phone size={24} />
      <span className="pulse-ring"></span>
    </a>
  );
};

export default MobilePhoneFAB;
